import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {UIChart} from 'primeng/chart';
import {HttpClient} from '@angular/common/http';
import {DatePipe} from '@angular/common';
import {BaseClientComponent} from '../../base-client.component';
import {AuthenticationService} from '../../../authenticationModule/services/authentication.service';
import {GraphService} from '../../../services/graph.service';
import {UtilsService} from '../../../appSharedModule/services/utils.service';
import {BwGraphUserConfigs, BwGraphUserConfigsService} from '../../../generated';
import {ActivatedRoute} from '@angular/router';
import {SelectItem} from 'primeng/api';
import * as _ from 'lodash';
import {GraphType} from '../../../Enum/graph-type.enum';
import moment from 'moment-timezone';
import {environment} from '../../../../environments/environment';
import {GraphHandlerService} from '../graph-handler.service';
import {switchMap} from 'rxjs/operators';
import 'chartjs-adapter-moment';
import zoomPlugin from 'chartjs-plugin-zoom';
import {TechnicalPopService} from '../../../services/technical-pop.service';

@Component({
  selector: 'app-market-data-qrd-mlr',
  templateUrl: './market-data-qrd-mlr-latency.component.html',
  styleUrls: ['./market-data-qrd-mlr-latency.component.scss']
})

export class MarketDataQrdMlrLatencyComponent extends BaseClientComponent implements OnInit {
  @ViewChildren('chart') charts !: QueryList<UIChart>;
  market2TransportListSelect: SelectItem[] = [];
  savedUserFilterConfigs: SelectItem[] = [];
  selectedMarketToTransportForList: any[] = [];
  loadedGraphs = [];
  selectedMarkets2Transport: any[] = [];
  markets2Transport: string[];
  timeZoneList = [];
  zoomOptions = [];
  periods = [];
  updateRoutesDisabled = true;
  loadingPrefs = true;
  noGraphs = false;
  zoomIn = false;
  showChangedConfigMessage = false;
  loadingGraphsStatus = false;
  refreshingGraphs = false;
  refreshingGraphIds = {};
  batchToLoad = 0;
  maxTime: number;
  minTime: number;
  batchedGraphs: any;
  userDefaultGraphsParams = {
    graphOption: {},
    selectedVvlans: [],
    selectedPeriod: {},
    zoomIn: false,
    timeZone: 'UTC',
    selectedConfiguration: null,
  };
  bwGraphUserDefaultConfig?: BwGraphUserConfigs;
  savedUserConfigs: Array<BwGraphUserConfigs>;
  checkboxesModel = {};
  graphData = {};
  graphStats = {};
  listObservable = {};
  readonly MLR_COLOR = '#2a78d6';
  readonly LATENCY_COLOR = '#199e70';
  private crosshairPlugin = {
    id: 'qrdMlrCrosshair',
    afterDraw: (chart: any) => {
      const activeElements = chart.tooltip && chart.tooltip.getActiveElements ? chart.tooltip.getActiveElements() : [];
      if (!activeElements.length) {
        return;
      }
      const x = activeElements[0].element.x;
      const ctx = chart.ctx;
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, chart.chartArea.top);
      ctx.lineTo(x, chart.chartArea.bottom);
      ctx.lineWidth = 1;
      ctx.strokeStyle = 'rgba(11, 11, 11, 0.28)';
      ctx.stroke();
      ctx.restore();
    }
  };
  chartPlugins = [zoomPlugin, this.crosshairPlugin];
  graphExecutionTimeOptions = {};
  defaultGraphExecutionTimeOptions = {};
  selectedPeriod: any = {};
  options: any;
  unit = 'hour';
  selectedTimeZone = 'UTC';
  selectedConfigurationId: string = null;
  selectedConfigurationName: string = null;

  constructor(public authenticationService: AuthenticationService,
              protected graphService: GraphService,
              protected utilsService: UtilsService,
              protected http: HttpClient, protected datePipe: DatePipe,
              protected technicalPopService: TechnicalPopService,
              private bwGraphUserConfigsService: BwGraphUserConfigsService,
              public route: ActivatedRoute,
              private graphHandlerService: GraphHandlerService) {
    super();
  }

  ngOnInit() {
    this.utilsService.lockUi();
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.ngOnChanges();
    });
    this.subscriptions.push(response$);
    this.periods = this.graphHandlerService.periods;
    this.zoomOptions = this.graphHandlerService.zoomOptions;
    this.timeZoneList = this.graphHandlerService.timeZoneList;

  }

  ngOnChanges() {
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      moment.tz.setDefault('UTC');
      const timeWindow = this.graphHandlerService.initMinAndMaxTime();
      this.minTime = timeWindow.minTime;
      this.maxTime = timeWindow.maxTime;
      this.initializeGraphExecutionTimeOption();
      this.getGraphInformation('market2Transport', 'market2TransportList', 'qrd-mlr-latency-graph-data');
    });
    this.subscriptions.push(response$);
  }

  private getGraphInformation(data, dataList, heartbeatOrQrdMlr) {
    this.graphHandlerService.loadUserConfigs().pipe(
      switchMap(() => this.graphService.getHeartbeatOrQrdMlrGraphsInformation(heartbeatOrQrdMlr))
    ).subscribe(res => {
      this.markets2Transport = res[data];
      this.market2TransportListSelect = res[dataList].sort((a, b) => a.label.localeCompare(b.label));
      this.initializeDataGraph(this.markets2Transport);
      this.utilsService.unlockUi();
    });
  }

  private initializeDataGraph(graphInformation) {
    if (!graphInformation || graphInformation.length <= 0) {
      this.noGraphs = true;
    } else {
      _.forEach(graphInformation, (data) => {
        this.selectedPeriod[data] = 360;
        this.checkboxesModel[data] = false;
      });
      this.initSavedConfigs();
      if (this.selectedConfigurationId) {
        this.loadSavedFilterConfiguration(this.bwGraphUserDefaultConfig);
      } else {
        this.utilsService.removeUserData('userQrdMlrGraphPref');
        this.loadDefaultUserPrefGraph();
      }
      this.loadFirstBatch();
    }
  }


  private saveUserDataInfo() {
    this.utilsService.saveUserData('userQrdMlrGraphPref', this.userDefaultGraphsParams);
  }

  private createSelectedDataGraphList(dataGraphListSelect, selectedDataGraph) {
    return this.graphHandlerService.createSelectedDataGraphList(dataGraphListSelect, selectedDataGraph);
  }

  private initializeUserDefaultGraphsParams(selectedIndex) {
    this.userDefaultGraphsParams.selectedVvlans = selectedIndex;
    this.userDefaultGraphsParams.selectedConfiguration = this.selectedConfigurationId;
    this.userDefaultGraphsParams.timeZone = this.selectedTimeZone;
    this.saveUserDataInfo();
    this.loadingPrefs = false;
    this.showChangedConfigMessage = false;
  }


  async updateDefaultConfiguration(oldConfigurations: Array<BwGraphUserConfigs>, newConfiguration: BwGraphUserConfigs = null) {
    const result = await this.graphHandlerService.updateDefaultConfiguration(
      oldConfigurations,
      newConfiguration,
      this.bwGraphUserDefaultConfig,
      this.selectedConfigurationId,
      this.showChangedConfigMessage
    );

    this.bwGraphUserDefaultConfig = result.bwGraphUserDefaultConfig;
    this.selectedConfigurationId = result.selectedConfigurationId;
    this.showChangedConfigMessage = result.showChangedConfigMessage;
  }

  reinitializeSelectedGraphs() {
    this.selectedMarkets2Transport = _.filter(this.markets2Transport,
      (market2Transport) => this.checkboxesModel[market2Transport] === true);
    this.selectedMarketToTransportForList = this.createSelectedDataGraphList(this.market2TransportListSelect, this.selectedMarkets2Transport);
    this.saveUserPrefs();
  }

  hideGraph(index) {
    _.forEach(this.markets2Transport, (market2Transport) => {
      this.checkboxesModel[market2Transport] = this.isDisplayedData(market2Transport);
    });
    this.checkboxesModel[index] = false;
    this.reinitializeSelectedGraphs();
  }

  loadSavedFilterConfiguration(configurationToLoad: BwGraphUserConfigs | null = null) {
    this.graphHandlerService.loadSavedFilterConfiguration(
      this.savedUserConfigs,
      this.selectedConfigurationId,
      this.bwGraphUserDefaultConfig,
      this.markets2Transport,
      this.defaultGraphExecutionTimeOptions,
      this.market2TransportListSelect,
      this.checkboxesModel,
      this.charts,
      configurationToLoad,
      this.showChangedConfigMessage
    ).then(result => {
      this.userDefaultGraphsParams = result.userDefaultGraphsParams;
      this.selectedConfigurationName = result.selectedConfigurationName;
      this.graphExecutionTimeOptions = this.applyThemeToSavedOptions(result.graphExecutionTimeOptions);
      this.charts.map((chart: UIChart) => {
        if (this.graphExecutionTimeOptions[chart.data.id]) {
          chart.options = this.graphExecutionTimeOptions[chart.data.id];
          chart.reinit();
        }
      });
      this.selectedTimeZone = result.selectedTimeZone;
      this.selectedMarkets2Transport = result.selectedMarkets2TransportOrChannels2Pop;
      this.selectedMarketToTransportForList = result.selectedMarketToTransportOrChannels2PopForList;
      this.zoomIn = result.zoomIn;
      this.selectedPeriod = result.selectedPeriod;
      this.loadingPrefs = result.loadingPrefs;
      this.showChangedConfigMessage = result.showChangedConfigMessage;
      this.loadFirstBatch();
    }).catch(() => {
    });
  }


  updateTimeScale(index) {
    this.graphHandlerService.applyTimeScaleUpdate(index, this.charts, this.selectedPeriod, this.minTime, this.userDefaultGraphsParams, () => this.saveUserDataInfo());
  }

  private reanchorRelativeTimeWindow(index: string) {
    this.graphHandlerService.reanchorRelativeTimeWindow(index, this.selectedPeriod, this.graphExecutionTimeOptions);
  }

  resetCharZoom(vvlan) {
    this.graphHandlerService.applyResetZoom(vvlan, this.charts, this.selectedPeriod, this.minTime, this.maxTime);
    this.saveUserPrefs();
  }

  saveUserPrefs(loadSelectedGraphs = false) {
    const result = this.graphHandlerService.saveUserPrefs(
      this.userDefaultGraphsParams,
      this.charts,
      this.selectedMarketToTransportForList,
      this.selectedMarkets2Transport,
      this.selectedPeriod,
      this.zoomIn,
      this.selectedConfigurationId,
      this.selectedTimeZone
    );
    this.userDefaultGraphsParams = result.userDefaultGraphsParams;
    this.showChangedConfigMessage = result.showChangedConfigMessage;
    this.updateRoutesDisabled = result.updateRoutesDisabled;
    this.charts = result.charts;
    this.saveUserDataInfo();
    this.reinitializeCheckBoxModel(this.markets2Transport, this.selectedMarkets2Transport);
    if (loadSelectedGraphs) {
      this.loadFirstBatch();
    }
    this.saveUserDataInfo();
  }

  resetFilters() {
    this.selectedMarkets2Transport = [];
    this.zoomIn = false;
    this.selectedTimeZone = 'UTC';
    this.selectedConfigurationId = null;
    this.selectedConfigurationName = null;
    _.forEach(this.markets2Transport, (market2TransportOrChannel2Pop) => {
      this.selectedMarkets2Transport.push(market2TransportOrChannel2Pop);
      this.selectedPeriod[market2TransportOrChannel2Pop] = 360;
      this.graphExecutionTimeOptions[market2TransportOrChannel2Pop] = _.cloneDeep(this.defaultGraphExecutionTimeOptions);
    });
    this.selectedMarketToTransportForList = this.createSelectedDataGraphList(this.market2TransportListSelect, this.selectedMarkets2Transport);
    this.reinitializeCheckBoxModel(this.markets2Transport, this.selectedMarkets2Transport);
    this.charts.map((chart: UIChart) => {
      chart.options.scales.x.max = null;
      chart.options.scales.x['time']['unit'] = this.unit;
      chart.options.scales.x.min = this.minTime;
      chart.reinit();
    });
    this.updateDefaultConfiguration([this.bwGraphUserDefaultConfig], null);
    this.saveUserPrefs();
    this.showChangedConfigMessage = false;
    this.loadFirstBatch();
  }

  loadDefaultUserPrefGraph() {
    this.loadingPrefs = true;
    const savedParams = this.utilsService.getUserData('userQrdMlrGraphPref');
    if (!savedParams) {
      _.forEach(this.markets2Transport, (markets2TransportOrChannels2Pop) => {
        this.graphExecutionTimeOptions[markets2TransportOrChannels2Pop] = _.cloneDeep(this.defaultGraphExecutionTimeOptions);
        this.selectedMarkets2Transport.push(markets2TransportOrChannels2Pop);
        this.checkboxesModel[markets2TransportOrChannels2Pop] = true;
      });
      this.selectedMarketToTransportForList = this.createSelectedDataGraphList(this.market2TransportListSelect, this.selectedMarkets2Transport);
      this.initializeUserDefaultGraphsParams(this.selectedMarkets2Transport);
      return;
    }
  }

  public loadNextGraphsBatch() {
    if (this.batchedGraphs && this.batchedGraphs[this.batchToLoad]) {
      _.forEach(this.batchedGraphs[this.batchToLoad], (index: string) => {
        this.loadGraphForQrdMlr(index);
      });
      this.batchToLoad++;
    }
  }

  onSelectGraphs() {
    this.selectedMarketToTransportForList = this.createSelectedDataGraphList(this.market2TransportListSelect, this.selectedMarkets2Transport);
    this.updateRoutesDisabled = this.selectedMarketToTransportForList.length === 0;
  }

  public loadFirstBatch() {
    this.batchToLoad = 0;
    const selectedData = this.selectedMarkets2Transport;
    this.batchedGraphs = _.chunk(selectedData, this.graphHandlerService.INFINIT_SCROLL_BATCH_SIZE);
    _.forEach(this.batchedGraphs[0], (index: string) => {
      this.loadGraphForQrdMlr(index);
    });
    this.batchToLoad++;
  }

  reinitializeCheckBoxModel(data, selectedData) {
    this.graphHandlerService.reinitializeCheckBoxModel(data, selectedData, this.checkboxesModel);
  }

  public saveFilterConfig() {
    this.saveUserPrefs();
    const configuration = _.find(this.savedUserFilterConfigs, {'label': this.selectedConfigurationName});
    if (configuration) {
      this.updateFilterConfiguration(configuration.value);
    } else {
      this.createNewFilterConfiguration();
    }
  }

  changeTimeZone() {
    this.selectedTimeZone = this.graphHandlerService.applyTimeZoneChange(this.selectedTimeZone, this.charts);
    this.saveUserPrefs();
  }

  public initSavedConfigs() {
    this.savedUserFilterConfigs = [];
    this.savedUserConfigs = this.authenticationService.userCurrent.bwGraphUserConfigs.filter(userConfig => userConfig.type === GraphType.MARKET_DATA_QRD_MLR);
    _.forEach(this.savedUserConfigs, (savedUserConfig: BwGraphUserConfigs) => {
      if (savedUserConfig.type === GraphType.MARKET_DATA_QRD_MLR) {
        this.savedUserFilterConfigs.push({
          label: savedUserConfig.configName, value: savedUserConfig.id,
        });
      }
    });
    this.savedUserFilterConfigs.sort((a, b) => a.label.localeCompare(b.label));
    if (this.authenticationService.userCurrent.bwGraphUserDefaultConfig && this.authenticationService.userCurrent.bwGraphUserDefaultConfig.filter(userDefaultConfig => userDefaultConfig.type === GraphType.MARKET_DATA_QRD_MLR).length > 0) {
      const defaultConfig = this.authenticationService.userCurrent.bwGraphUserDefaultConfig.filter(userDefaultConfig => userDefaultConfig.type === GraphType.MARKET_DATA_QRD_MLR);
      this.bwGraphUserDefaultConfig = _.find(this.authenticationService.userCurrent.bwGraphUserConfigs, {'id': defaultConfig[0]['id']});
      this.selectedConfigurationId = (this.bwGraphUserDefaultConfig) ? this.bwGraphUserDefaultConfig.id : null;
    }
  }

  createNewFilterConfiguration() {
    const configuration = this.utilsService.loadUserPref('userQrdMlrGraphPref');
    const graphConfiguration = <BwGraphUserConfigs>{
      configName: this.selectedConfigurationName,
      config: configuration,
      user: '/api/users/' + this.authenticationService.userCurrent.id,
      createdBy: this.authenticationService.userCurrent.email,
      type: GraphType.MARKET_DATA_QRD_MLR,
      isDefault: true,
    };
    this.bwGraphUserConfigsService.postBwGraphUserConfigsCollection(graphConfiguration).subscribe({
      next: (config) => {
        this.authenticationService.userCurrent.bwGraphUserConfigs.push(config);
        this.updateDefaultConfiguration(this.authenticationService.userCurrent.bwGraphUserConfigs, config);
        this.initSavedConfigs();
      }, error: (error) => {
        this.utilsService.handleErrorWebservice$(error);
      }
    });
  }

  isDisplayedData(index) {
    if (!this.selectedMarkets2Transport) {
      return true;
    }
    return this.selectedMarkets2Transport.some(selected => String(selected) === String(index));
  }

  reloadCharts(index) {
    this.charts.map((chart: UIChart) => {
      if (chart.data.id === index) {
        this.userDefaultGraphsParams.graphOption[index] = chart.options;
        this.utilsService.saveUserData('userQrdMlrGraphPref', this.userDefaultGraphsParams);
        chart.reinit();
      }
    });
  }

  getGraphLegend(index: string) {
    const list = this.market2TransportListSelect;
    const data = _.find(list, {'value': index});
    if (data) {
      return data.label;
    } else {
      return index;
    }
  }

  getTechnicalPopFromLabel(index: string) {
    return this.graphHandlerService.extractTechnicalPop(this.getGraphLegend(index), /@(.{3})/);
  }

  updateFilterConfiguration(configurationId: string) {
    const configuration = this.utilsService.loadUserPref('userQrdMlrGraphPref');
    const graphConfiguration = <BwGraphUserConfigs>{
      configName: this.selectedConfigurationName,
      config: configuration,
      type: GraphType.MARKET_DATA_QRD_MLR,
      isDefault: true,
    };
    this.bwGraphUserConfigsService.putBwGraphUserConfigsItem(configurationId, graphConfiguration)
      .subscribe({
        next: (config) => {
          this.authenticationService.userCurrent.bwGraphUserConfigs.map((item) => {
            if (item.id === configurationId) {
              item = config;
            }
          });
          this.showChangedConfigMessage = false;
        }, error: (error) => {
          this.utilsService.handleErrorWebservice$(error);
        }
      });
  }

  refreshGraphsData() {
    const routesToRefresh = _.filter(this.markets2Transport, (route) => this.listObservable[route] && this.isDisplayedData(route));
    if (routesToRefresh.length === 0) {
      return;
    }
    this.refreshingGraphs = true;
    let remaining = routesToRefresh.length;
    const onRouteDone = () => {
      remaining--;
      if (remaining <= 0) {
        this.refreshingGraphs = false;
      }
    };
    _.forEach(routesToRefresh, (route) => this.loadGraphForQrdMlr(route, true, onRouteDone));
  }

  refreshSingleGraph(index) {
    if (this.refreshingGraphIds[index]) {
      return;
    }
    this.refreshingGraphIds[index] = true;
    this.loadGraphForQrdMlr(index, true, () => {
      this.refreshingGraphIds[index] = false;
    });
  }

  private loadGraphForQrdMlr(market2Transport: string, forceRefresh = false, onComplete?: () => void) {
    this.loadingGraphsStatus = true;
    if (!market2Transport) {
      if (onComplete) {
        onComplete();
      }
      return;
    }
    if (!this.isDisplayedData(market2Transport)) {
      this.loadingGraphsStatus = false;
      if (onComplete) {
        onComplete();
      }
      return;
    }
    if (this.graphData[market2Transport] && !forceRefresh) {
      this.loadingGraphsStatus = false;
      this.loadedGraphs.push(market2Transport);
      if (onComplete) {
        onComplete();
      }
      return;
    }
    if (!forceRefresh) {
      this.loadedGraphs.push(market2Transport);
    }
    this.listObservable[market2Transport] = this.http.get<any>(environment.baseUrlWs + '/api/qrd-mlr-graph-latency?marketPop=' + market2Transport).subscribe({
      next: (response: any) => {
        this.graphHandlerService.applyTwoSeriesGraphResponse(
          response, market2Transport, 'MLR', this.MLR_COLOR, this.LATENCY_COLOR,
          this.graphData, this.graphStats, this.charts, forceRefresh,
          (idx) => this.reanchorRelativeTimeWindow(idx)
        );
        this.loadingGraphsStatus = false;
        if (onComplete) {
          onComplete();
        }
      }, error: () => {
        this.graphHandlerService.applyGraphLoadError(this.graphData, market2Transport);
        this.loadingGraphsStatus = false;
        if (onComplete) {
          onComplete();
        }
      }
    });
  }

  private exportFileName(index: string, extension: string) {
    return this.graphHandlerService.buildExportFileName(this.getGraphLegend(index), '-mlr-latency-', extension);
  }

  exportCsv(index: string) {
    this.graphHandlerService.exportTwoSeriesCsv(this.graphData, index, 'MLR', this.exportFileName(index, 'csv'));
  }

  exportPng(index: string) {
    this.graphHandlerService.exportChartPng(this.charts, index, this.exportFileName(index, 'png'));
  }

  private onZoomComplete(chart: any): void {
    this.graphHandlerService.applyZoomComplete(this.graphExecutionTimeOptions, chart, () => this.saveUserPrefs());
  }

  private initializeGraphExecutionTimeOption() {
    this.defaultGraphExecutionTimeOptions = this.graphHandlerService.getThemedGraphExecutionTimeOptions(this.onZoomComplete.bind(this));
    this.defaultGraphExecutionTimeOptions['scales'] = this.graphHandlerService.setThemedMlrLatencyScales(this.minTime, this.unit, this.maxTime);
    this.options = this.graphHandlerService.getCommonOption();
  }

  private applyThemeToSavedOptions(savedOptionsByGraph: any): any {
    return this.graphHandlerService.applyThemeToSavedOptions(savedOptionsByGraph, this.defaultGraphExecutionTimeOptions);
  }
}
